import domReady from '@wordpress/dom-ready';

domReady(() => {
  const btns = document.querySelectorAll(
    '.btn, .btn--outline, .btn--secondary'
  );

  if (btns) {
    btns.forEach((button) => {
      if (button.classList.contains('btn--secondary')) {
        button.innerHTML =
          button.innerHTML + '<span class="icon icon-coeur"></span>';
      } else {
        button.innerHTML =
          button.innerHTML + '<span class="icon icon-arrow"></span>';
      }
    });
  }
});
